import { DataType } from '../../../../tables'
import { useStockHooks } from "../../hooks/stockHooks"
import { FieldType, FieldValue, FilterField, Filters, O } from "../../../../features/ui"
import { useEffect, useState } from 'react'
import { useManagerHooks } from '../../../manager'
import { Stock } from '../../state/types'

type Props = {
    stocks: Stock[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'stock'

export const StockFilters = (props: Props) => {
    const { stocks, onSearchStart, onSearchDone } = props

    const [searchText, setSearchText] = useState<string>()

    const { currentBranchId } = useManagerHooks()

    const { searchStockList } = useStockHooks()
    
    useEffect(() => {
        search(searchText)
    }, [stocks])

    const search = async (searchTextParam?: string) => {
        onSearchStart()
        let stockList = stocks.filter(stock => stock.branchId === currentBranchId)
        stockList = await searchStockList(stockList, searchTextParam)
        setTimeout(() => onSearchDone(stockList), 100)
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar producto por nombre, código o proveedor',
        icon: 'search',
        onChange: handleSearch
    }

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
        />
    )
}
